import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './quotes.css'; 
import { DataGrid } from '@mui/x-data-grid';
import {
  Box,
  Collapse,
  Typography,
  CircularProgress,
  Paper
} from '@mui/material';
import { IconButton } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Tooltip from '@mui/material/Tooltip';
import HistoryIcon from '@mui/icons-material/History';

import { Link } from 'react-router-dom';
import { authFetch } from './utils/api';
import { getFilterForUser } from './utils/utils';
import { getStatusFilterForUser } from './utils/utils';

const Archive = () => {
  const location = useLocation();
  const { quoteId: selectedQuoteFromNav } = location.state || {};
  
  const [quotes, setQuotes] = useState([]);
  const [expandedRow, setExpandedRow] = useState(null);
  const [itemQuotes, setItemQuotes] = useState({});
  const [loadingItemQuotes, setLoadingItemQuotes] = useState(false);



  const [selectedRow, setSelectedRow] = useState(null);
  const [isHistoryOpen, setHistoryOpen] = useState(false);
  const [historyData, setHistoryData] = useState([]);

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });


  useEffect(() => {
    if (selectedQuoteFromNav) {
      setExpandedRow(selectedQuoteFromNav);
      fetchItemQuotes(selectedQuoteFromNav);
    }
  }, [selectedQuoteFromNav]);
  
  // Load quotes on mount
useEffect(() => {
 
  const filter = getFilterForUser();
  const status = getStatusFilterForUser('Quote Submitted')
  authFetch(`/quotes/archive/quotesbyuser/${filter}${status}`)
  //authFetch(`/quotes/quotesbyuser/${filter}&status=Quote%20Submitted`)
    .then(setQuotes)
    .catch(err => {
      console.error('Failed to fetch quotes:', err);
      // Handle unauthorized (redirect to login if 401)
      if (err.message.includes('401')) {
        handleLogout();
      }
    });
}, []);

// Fetch item quotes for selected quote
const fetchItemQuotes = async (quoteId) => {
  setLoadingItemQuotes(true);
  try {
    //const data = await authFetch(`/itemquotes/byquote/${quoteId}`);
    const data = await authFetch(`/itemquotes/archive/${quoteId}`);
    //alert(JSON.stringify(data, null, 2));
    setItemQuotes(prev => ({ ...prev, [quoteId]: data }));
  } catch (err) {
    console.error('Failed to fetch item quotes:', err);
    setItemQuotes(prev => ({ ...prev, [quoteId]: [] }));
    if (err.message.includes('401')) {
      handleLogout();
    }
  } finally {
    setLoadingItemQuotes(false);
  }
};


  // Handle row click
  const handleRowClick = (params) => {
    const quoteId = params.id;
    if (expandedRow === quoteId) {
      setExpandedRow(null);
    } else {
      setExpandedRow(quoteId);
      if (!itemQuotes[quoteId]) fetchItemQuotes(quoteId);
    }
  };

  const handleViewHistory = async (quoteId) => {
    setHistoryOpen(true);  // ✅ Open dialog
    
    console.log("Fetching history for QuoteID:", quoteId);
    try {
        const data = await authFetch(`/quotehistory/${quoteId}`);
        setHistoryData(data);  // ✅ Store fetched history
    } catch (err) {
        console.error("Failed to fetch history:", err);
        setHistoryData([]);  // ✅ Ensure no undefined errors
    }
};

  // DataGrid columns
  const columns = [
    { field: 'id', headerName: 'ID', width: 90 },
    { field: 'quote_name', headerName: 'Quote Name', width: 200 },
    //{ field: 'fkCustomerId', headerName: 'Customer ID', width: 100},
    { field: 'customer_name', headerName: 'Customer', width: 100},

    { field: 'created_at', headerName: 'Date', width: 200,
       valueFormatter: (value) => {
            if (!value) return '';
            const [date, time] = value.split('T');
            const [hours, minutes] = time.split(':');
            return `${date} ${hours}:${minutes}`;
        }
     },
    { field: 'user_name', headerName: 'Created By', width: 150 },

    { field: 'reference_no', headerName: 'Reference No.', width: 200 },
    { field: 'tags', headerName: 'Tags', width: 200 },
    { field: 'status', headerName: 'status', width: 150 },
    { field: 'QuoteID', headerName: 'Quote #', width: 150 },

    {
      field: "view_history",
      headerName: "History",
      width: 120,
      renderCell: (params) => (
          <button 
              onClick={() => handleViewHistory(params.row.QuoteID)}
              style={{
                  background: "none", 
                  border: "none", 
                  cursor: "pointer",
                  color: "#1976d2", // Match MUI theme color
                  fontSize: "1rem",
              }}
              title="View Quote History"
          >
              <HistoryIcon />
          </button>
      )
  }

  
  
  ];
  // Get current item quotes safely
  const quoteItems = Array.isArray(itemQuotes[expandedRow])
    ? itemQuotes[expandedRow]
    : [];
    //alert(JSON.stringify(quoteItems, null, 2));
  const selectedQuote = quotes.find(q => q.id === expandedRow);
  const fkCustomerId  = selectedQuote?.fkCustomerId;
  const fkUserId      = selectedQuote?.fkUserId;
  const reference_no  = selectedQuote?.reference_no;
  const viewItem          = 'readonly';

  return (    
    <Box>
      {/* Add New Quote Button */}
      <Paper sx={{ p: 2, marginBottom: 2 }}>
      <h3>Archive</h3>
      </Paper>
      <div style={{ height: 300, width: '100%' }}>
        <DataGrid

          pageSize={10}
          pagination
          paginationModel={paginationModel}
          onPaginationModelChange={(model) => setPaginationModel(model)}
          rowsPerPageOptions={[10, 20, 50]} // 👈  dropdown options
          pageSizeOptions={[10, 20, 50]}    // 👈 fallback for older versions

          rows={quotes}
          columns={columns}
          getRowId={(row) => row.id}
          rowHeight={30}
          sx={{
            '& .MuiDataGrid-cell': {
              fontSize: '0.95rem',
              fontFamily: 'Arial, sans-serif',
            },
            '& .MuiDataGrid-columnHeaders': {
              fontSize: '1rem',
              fontWeight: 'bold',
            },
            '& .MuiDataGrid-row.Mui-selected': {
              backgroundColor: '#e3f2fd',
            },
            '& .MuiDataGrid-row.Mui-selected:hover': {
              backgroundColor: '#bbdefb',
            },
            '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
              outline: 'none !important',
            },
            '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
              outline: 'none !important',
            },
          }}
          onRowClick={handleRowClick}
          rowSelectionModel={expandedRow ? [expandedRow] : []}
        />
      </div>

        {expandedRow && (
    <Collapse in={true} timeout="auto" unmountOnExit>
    <Paper elevation={1} sx={{ mt: 2, p: 2, backgroundColor: '#f9f9f9' }}>
      <Typography variant="h6">
        Quote #{expandedRow} Details 
      </Typography>

      {loadingItemQuotes ? (
        <CircularProgress />
      ) : quoteItems.length > 0 ? (
        <>
          {/* Table layout for better alignment */}
          <table className="table-sm" style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th>Sub ID</th>
                <th>Item</th>
                <th>Type</th>
                <th style={{ width: '150px' }}>created at</th>
                <th style={{ width: '150px' }}>updated at</th>

                <th style={{ width: '100px' }}>Total</th>
                <th style={{ width: '100px' }}> Tax</th>
                <th style={{ width: '100px' }}>Subtotal</th>
                <th style={{ width: '50px' }}>Qty</th>
                <th style={{ width: '50px' }}>View</th>
              </tr>
            </thead>
            <tbody>
              {quoteItems.map(item => (
                <tr 
                    key={item.id} 
                    className={selectedRow === item.id ? "selected-row" : "hover-row"}


                    onClick={() => setSelectedRow(item.id)} // ✅ Update selection on row click
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f0f0f0"}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}                  
                >

                  <td>{item.subId}</td>
                  <td>{item?.doorData?.frameData?.selectedDoor?.name}</td>
                  <td>{item?.doorData?.document?.type}</td>
                  <td>
                   {item?.created_at
                      ? `${item.created_at.split('T')[0]} ${item.created_at.split('T')[1].slice(0, 5)}`
                      : 'N/A'}                    
                  </td>
                  <td>
                    {item?.updated_at
                      ? `${item.updated_at.split('T')[0]} ${item.created_at.split('T')[1].slice(0, 5)}`
                      : 'N/A'}
                  </td>
                  <td>{item?.doorData?.calc?.total}</td>
                  <td>{item?.doorData?.calc?.tax}</td>
                  <td>{item?.doorData?.calc?.subtotal}</td>
                  <td>{item?.doorData?.frameData?.quantity}</td>
                  <td>
                  {/*console.log('maremala:' + JSON.stringify({item}, null, 2))*/}
                    <Link to={`/${item.itemType}`} state={{ quoteId: item.fkQuoteId, quoteItemId: item.id, 
                                                            fkCustomerId: fkCustomerId, fkUserId: fkUserId, subId: item.subId, 
                                                            reference_no: reference_no, viewItem: viewItem  }}>
                      <Tooltip title="View Item">
                        <IconButton size="small" color="primary">
                          <VisibilityIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* AddItem component */}
 
        </>
      ) : (
        <>
        <Typography variant="body2" color="textSecondary">
          No items found.
        </Typography>
        <div>
          {/* AddItem component */}
        </div>
        </>    
      )}
    </Paper>
  </Collapse>

         )}

    </Box>
  );
};

export default Archive;
